import React, { Component } from 'react';
import { connect } from 'react-redux';
import { translate } from '@haldor/ui';
import { withRouter } from 'react-router-dom';

import { getGroupById } from 'actions/groups';
import { setPageTitle, setPageActions } from 'actions/header';
import { createBaseGroup, clearActiveBaseGroup } from 'actions/basegroups';

import { Spinner } from 'UI';

import SectionBaseGroups from 'containers/Section/Functionality/SectionBaseGroups';
import BaseGroupForm from 'containers/BaseGroups/Form/BaseGroupForm';
import Modal from 'containers/Modals/Modal';

class SectionBaseGroupPage extends Component {

	constructor(props) {
		super(props);

		this.state = {
			loading: true,
			createModal: false,
			group: null
		};
	}

	componentDidMount = async () => {
		const { groupId } = this.props.match.params;

		this.setState({ loading: true });

		let groupFromStore = await this.props.getGroupById(groupId, ['members']);
		this.setState({ group: groupFromStore, loading: false });
		this.props.setPageTitle(groupFromStore.title);

		this.props.setPageActions([
			{
				value: this.props.translate('create-basegroup'),
				type: 'button',
				onClick: this.toggleCreateModal,
				icon: 'plus',
			},
		]);
	}

	componentWillUnmount = () => {
		this.props.clearActiveBaseGroup();
	}

	onCreateBaseGroup = async (values) => {
		await this.props.createBaseGroup(values);
		this.setState({ createModal: false });
	}

	toggleCreateModal = () => {
		this.setState({ createModal: !this.state.createModal });
	}

	render() {
		if (this.state.loading) {
			return (
				<div>
					<Spinner center />
				</div>
			);
		}

		const { translate } = this.props;
		let { group } = this.state;

		return (
			<div>
				<Modal isOpen={this.state.createModal} title={translate('create-basegroup')} type="small" onClose={this.toggleCreateModal}>
					<div className="form">
						<div className="form-row">
							<BaseGroupForm onSubmit={this.onCreateBaseGroup} group={group} />
						</div>
					</div>
				</Modal>

				<div>
					<SectionBaseGroups group={group} />
				</div>
			</div>
		);
	}

}

function mapStateToProps(state) {
	return {
		translate: translate(state.Languages.translations),
	}
}

export default withRouter(connect(mapStateToProps, {
	getGroupById,
	setPageTitle,
	setPageActions,
	createBaseGroup,
	clearActiveBaseGroup,
})(SectionBaseGroupPage));